export enum SmartLinkDataGridField {
  TITLE = 'title',
  DESCRIPTION = 'description',
  URL = 'url',
  VARIANT = 'variant',
  EXTERNAL = 'external',
  HIDDEN = 'hidden',
}

export type SmartLinkDataGridFieldType = `${SmartLinkDataGridField}`;
